module.exports = __webpack_public_path__ + "media/a3.d3059af2.wav";